// react
import React from "react"
// material-ui
import { Card, CardHeader, CardActions, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
import MenuItem from "material-ui/MenuItem"
import Checkbox from "material-ui/Checkbox"
import MUISelectField from "material-ui/SelectField"
// app
import TextField from "components/common/TextField"
import "./style.styl"


const initialState = {
    firstname_error: true,
    lastname_error: true,
    email_error: true,
    password_error: true,
    accepted: false,
    type: "Pilot",
    showTerms: false,
    showPrivacy: false
}

class UserSignUp extends React.Component {
    constructor(props) {
        super(props)
        this.state = initialState

        this.setFirstname = (firstname) => this.setState({ firstname })
        this.errorFirstname = (firstname_error) => this.setState({ firstname_error })
        this.setLastname = (lastname) => this.setState({ lastname })
        this.errorLastname = (lastname_error) => this.setState({ lastname_error })
        this.setEmail = (email) => this.setState({ email })
        this.errorEmail = (email_error) => this.setState({ email_error })
        this.setPassword = password => this.setState({ password })
        this.errorPassword = password_error => this.setState({ password_error })
        this.setType = (e, key, type) => this.setState({ type })
        this.setAccepted = (e, accepted) => this.setState({ accepted })

        this.save = this.save.bind(this)
    }

    save() {
        const { firstname, lastname, email, password, type } = this.state

        this.props.onSave({
            firstname, lastname, email, password, type
        })
    }

    render() {
        return (
            <div>
                <Card className="card">
                    <CardHeader title="Create a new profile with us:" />
                    <CardText className="clearfix">
                        <div className="float-left">
                            <TextField
                                autoFocus={ true }
                                label="Firstname"
                                mandatory={ true }
                                onChange={ this.setFirstname }
                                onError={ this.errorFirstname }
                            />
                            <br />
                            <TextField
                                label="Lastname"
                                mandatory={ true }
                                onChange={ this.setLastname }
                                onError={ this.errorLastname }
                            />
                            <br />
                            <TextField
                                label="Email"
                                mandatory={ true }
                                onChange={ this.setEmail }
                                onError={ this.errorEmail }
                            />
                            <br />
                            <TextField
                                label="Password"
                                mandatory={ true }
                                type="password"
                                onChange={ this.setPassword }
                                onError={ this.errorPassword }
                            />
                            <br />
                            <MUISelectField
                                floatingLabelText="I am a...*"
                                onChange={ this.setType }
                                fullWidth={ true }
                                value={ this.state.type }
                            >
                                <MenuItem
                                    value="Engineer"
                                    key="Engineer"
                                    primaryText="Engineer" />
                                <MenuItem
                                    value="Flight Attendant"
                                    key="Flight Attendant"
                                    primaryText="Flight Attendant" />
                                <MenuItem
                                    value="Manager"
                                    key="Manager"
                                    primaryText="Manager" />
                                <MenuItem
                                    value="Pilot"
                                    key="Pilot"
                                    primaryText="Pilot" />
                            </MUISelectField>
                            <br /><br />
                            <Checkbox 
                                label="I accept the Terms and Conditions and the Privacy Statement."
                                onCheck={ this.setAccepted }
                            />
                            <a
                                className="signup"
                                href="https://www.aviationnetwork.com/terms-and-conditions.html"
                                target="_blank">
                                Terms and Conditions
                            </a><br />
                            <a
                                className="signup"
                                href="https://www.aviationnetwork.com/dataprotection.html"
                                target="_blank">
                                Data Protection
                            </a>
                        </div>
                    </CardText>
                    <CardActions>
                        <FlatButton
                            label="Create"
                            primary={ true }
                            disabled={
                                this.state.firstname_error ||
                                this.state.lastname_error ||
                                this.state.email_error ||
                                this.state.password_error ||
                                this.state.type === "" ||
                                this.state.accepted !== true
                            }
                            onClick={ this.save }
                        />
                    </CardActions>
                </Card>
            </div>
        )
    }
}

export default UserSignUp



/** WEBPACK FOOTER **
 ** ./src/components/user/SignUp/user-signup.js
 **/